import React, { forwardRef } from 'react';

import { TextareaWrap, Textarea, Count } from './styled';

const TextareaComponent = forwardRef(({
  contentWidth = '100%',
  contentHeight = '108px',
  maxCount,
  ...props
}, ref) => {
  return (
    <TextareaWrap
      contentWidth={contentWidth}
      contentHeight={contentHeight}
    >
      <Textarea {...props} maxCount={maxCount} />
      {maxCount && <Count>{props.value?.toString().length ?? 0}/{maxCount}</Count>}
    </TextareaWrap>
  );
});

export default TextareaComponent;
